import { IIconName } from '@features/siteStatusV2/components/icon/Icon';
import { EligibilityStatus } from '@features/siteStatusV2/constants';
import theme from '@theme';

interface BadgeInformations {
  textColor: string;
  backgroundColor: string;
  badgeText: string;
  informations: string;
  badgeIcon?: IIconName;
}

const MapBadgeInformations: Record<EligibilityStatus, BadgeInformations> = {
  ELIGIBLE: {
    backgroundColor: theme.palette.green[100],
    textColor: theme.palette.green[600],
    badgeText: 'buildingDetail.badges.eligibility.eligible.name',
    informations: 'buildingDetail.badges.eligibility.eligible.precision'
  },
  FROZEN_ADDRESS: {
    backgroundColor: theme.palette.red[100],
    textColor: theme.palette.red[500],
    badgeText: 'buildingDetail.badges.eligibility.frozen.name',
    informations: 'buildingDetail.badges.eligibility.frozen.precision',
    badgeIcon: { iconName: 'open-link' }
  },
  NOT_ELIGIBLE: {
    backgroundColor: theme.palette.grey[200],
    textColor: theme.palette.grey[600],
    badgeText: 'buildingDetail.badges.eligibility.notEligible.name',
    informations: 'buildingDetail.badges.eligibility.notEligible.precision'
  },
  TARGETED: {
    backgroundColor: theme.palette.yellow[200],
    textColor: theme.palette.yellow[600],
    badgeText: 'buildingDetail.badges.eligibility.targeted.name',
    informations: 'buildingDetail.badges.eligibility.targeted.precision'
  },
  IN_DEPLOYMENT: {
    backgroundColor: theme.palette.yellow[200],
    textColor: theme.palette.yellow[600],
    badgeText: 'buildingDetail.badges.eligibility.inDeployment.name',
    informations: 'buildingDetail.badges.eligibility.inDeployment.precision'
  },
  CONNECTION_ON_DEMAND: {
    backgroundColor: theme.palette.yellow[200],
    textColor: theme.palette.yellow[600],
    badgeText: 'buildingDetail.badges.eligibility.connectionOnDemand.name',
    informations: 'buildingDetail.badges.eligibility.connectionOnDemand.precision'
  },
  RAD_IN_DEPLOYMENT: {
    backgroundColor: theme.palette.yellow[200],
    textColor: theme.palette.yellow[600],
    badgeText: 'buildingDetail.badges.eligibility.radInDeployment.name',
    informations: 'buildingDetail.badges.eligibility.radInDeployment.precision'
  },
  NO_STATUS: {
    backgroundColor: theme.palette.grey[200],
    textColor: theme.palette.grey[600],
    badgeText: 'buildingDetail.badges.eligibility.noStatus.name',
    informations: 'buildingDetail.badges.eligibility.noStatus.precision'
  }
};

export default MapBadgeInformations;
